<template>
  <div>
    <!-- 搜索流量分析工具的入口新手引导
          如果有其他工具需要加，可以联系PM骁骑，下掉该提示，换上新的；下掉的同时，可以考虑将相关组件一起清理 -->
    <global-tips></global-tips>

    <div class="promotion-header ad-d-flex ad-d-flex-between">
      <!--<div class="ad-d-flex ad-d-flex-start">-->
        <!--<byted-icon name="company"></byted-icon>-->
        <!--<div class="promotion-header-advertiser-name ad-m-l-xxs">{{account.advertiser_name}}</div>-->
      <!--</div>-->

      <div class="ad-d-flex ad-d-flex-between">
        <div class="ad-d-flex ad-d-flex-start" v-show="hasAccountData">

          <div class="ad-d-flex ad-m-r-lg">
            <byted-popover
              v-if="account.is_branding_advertiser"
              offset="120px"
              class="balance-popover"
              placement="bottom"
              width="287px"
              trigger="hover">
              <span class="ad-font-size ad-color-text bui-num balance-popover-header">
              消耗构成说明
              </span>
              <div class="balance-explain">
                <p>今日消耗=今日竞价广告消耗+今日品牌广告消耗</p>
                <p>今日竞价广告消耗：{{account.bid_cost ? account.bid_cost:'0'}}元</p>
                <p>今日品牌广告消耗：{{account.brand_cost ? account.brand_cost:'0'}}元</p>
              </div>
              <byted-icon slot="reference" height="13px" width="13px" name="question-circle"></byted-icon>
            </byted-popover>
            <span class="promotion-header-title">{{ $bp_t('今日消耗', 'bp.promotion_header_consumption_today') }}({{$bp_t('元', 'common.element')}}) </span>
            <span class="promotion-header-money bui-num">{{account.today_cost}}</span>
          </div>

          <div class="ad-d-flex">
            <byted-popover
              v-if="account.is_branding_advertiser"
              offset="80px"
              class="balance-popover"
              placement="bottom"
              width="200px"
              trigger="hover">
              <div slot="body">
                账户日预算：仅对竞价广告生效
              </div>
              <byted-icon slot="reference" height="13px" width="13px" name="question-circle"></byted-icon>
            </byted-popover>
            <span class="promotion-header-title">{{ $bp_t('账户日预算', 'bp.promotion_header_daily_budget_of_account') }}({{$bp_t('元', 'common.element')}}) </span>
            <span class="promotion-header-money ad-m-r-xs bui-num">
              {{isNoLimitBudgetMode ?  $bp_t('不限', 'common.unlimited') : account.budget}}
            </span>
            <byted-icon name="edit" @click="onClickEditAccountBudget" class="promotion-header-money-edit"></byted-icon>
            <div :class="[account.budget_task_info ? 'promotion-header-have-bid' : 'promotion-header-clock']">
              <byted-popover
                :disabled="!account.budget_task_info"
                placement='bottom'
                :title="$bp_t('预算设置提示', 'common.tips_for_budget_setting')"
                trigger='hover'
                width='250px'
                transfer>
                <template slot='header'>
                  {{ $bp_t('已设置定时任务', 'common.scheduled_task_set') }}
                  <div class='pull-right'>
                    <a href='javascript:void(0)' class='ad-link-text-btn time-task' @click="onClickEditAccountTimeTask">{{ $bp_t('修改', 'common.modify') }}</a>
                    <a href='javascript:void(0)' class='ad-link-text-btn time-task time-task-delate' @click="onDeleteAccountimeTask">{{ $bp_t('删除', 'common.delete') }}</a>
                  </div>
                </template>
                <template slot='body'>
                  {{ $bp_t(`预算将于次日00:00改为${account.budget_task_info ? account.budget_task_info.budget : 0}元`, 'common.promotion_budget_will_be_next_day', {data: account.budget_task_info ? account.budget_task_info.budget : 0}) }}
                </template>
                <byted-icon name="clock"
                            :class="{'active': !!account.budget_task_info}"
                            @click="onClickEditAccountTimeTask"
                            slot='reference'></byted-icon>
              </byted-popover>
            </div>
          </div>

          <div class="progress-wrapper ad-d-flex ad-d-flex-start"
               v-if="!isNoLimitBudgetMode">
            <byted-popover
              v-if="account.is_branding_advertiser"
              offset="80px"
              class="balance-popover"
              placement="bottom"
              width="262px"
              trigger="hover">
              <div slot="body">
               日消耗进度=今日竞价广告消耗/账户日预算<br>
               不包含品牌广告消耗与预算
              </div>
              <byted-icon slot="reference" height="13px" width="13px" name="question-circle"></byted-icon>
            </byted-popover>
            <div class="promotion-header-title">{{ $bp_t('日消耗进度', 'bp.promotion_header_daily_consumption_progress') }}</div>
            <byted-popover
                    transfer
                    ref="progressPop"
                    placement="top"
                    trigger="hover"
                    width="auto">
              <div slot="reference" class="promotion-header-progress">
                <byted-progress status="info"
                                :percent="costPercentage"
                                v-popover:progressPop></byted-progress>
              </div>
              <template slot="body">
                {{ $bp_t('今日消耗', 'bp.promotion_header_consumption_today') }}：<span class="promotion-header-money bui-num">{{account.today_cost}} </span>{{$bp_t('元', 'common.element')}}
              </template>
            </byted-popover>

            <div class="promotion-header-money bui-num ad-m-l">{{costPercentage}}%</div>
          </div>
          <div class="ad-spliter"></div>

          <div class="ad-d-flex">
            <byted-popover offset="80px"
              class="balance-popover"
              placement="bottom"
              width="240px"
              trigger="hover">
              <span class="ad-font-size ad-color-text bui-num balance-popover-header">
                {{ $bp_t('账户余额构成说明', 'bp.promotion_header_account_balance_composition') }}
                <a class="ad-link-text-btn" target="_black" :href="globalUpdateQuery('/overture/cash/flow/')">查看详情</a>
              </span>
              <div class="balance-explain">
                <p>{{ $bp_t('账户余额=赠款余额+非赠款余额', 'bp.promotion_header_account_balance_grant') }}</p>
                <p>{{ $bp_t('您的赠款余额有', 'bp.promotion_header_grant_balance') }}：{{account.grant}}{{ $bp_t('元', 'common.element') }}</p>
                <p>{{ $bp_t('您的非赠款余额有', 'bp.promotion_header_non_grant_balance') }}：{{account.cash}}{{ $bp_t('元', 'common.element') }}</p>
                <p>{{ $bp_t('您的可用余额有', 'bp.promotion_header_available_balance') }}：{{account.valid_balance}}{{ $bp_t('元', 'common.element') }}</p>
              </div>
              <byted-icon slot="reference" height="13px" width="13px" name="question-circle"></byted-icon>
            </byted-popover>
            <span class="promotion-header-title">{{ $bp_t('账户余额', 'bp.promotion_header_account_balance') }}({{$bp_t('元', 'common.element')}}) </span>
            <span class="promotion-header-money bui-num">{{account.balance}}</span>
          </div>
          <div class="ad-link recharge-btn"
               v-if="showRechargeBtn"
               @click="onClickRecharge">{{ $bp_t('充值', 'bp.promotion_header_recharge') }}</div>
          <div class="ad-d-flex ad-m-l-lg grant-balance" v-show="account.is_share_wallet">
            <byted-popover offset="-20px" class="balance-popover" placement="bottom" width="287px" trigger="hover" @visible-change="visibleChange">
              <div class="balance-explain" style="margin-top: 0;">
                <p>{{ advertiserSharedStrategyText[account.advertiser_shared_strategy_type]}}</p>
                <p v-for="(item, index) in account.advertiser_wallet_balance" :key="index" class="balance-explain-mess">
                  {{item.grant}}元将于 {{item.end_date}} 到期清空
                </p>
              </div>
              <byted-icon
                slot="reference"
                height="14px"
                width="14px"
                :color="walletBalanceSoon ? '#FAAD15' : balancePopoverHover ? '#666' : '#999' "
                :name="walletBalanceSoon ? 'exclamation-circle' : 'question-circle'"
              ></byted-icon>
            </byted-popover>
            <span class="promotion-header-title">{{ $bp_t('共享赠款余额', 'bp.promotion_header_account_balance') }}({{$bp_t('元', 'common.element')}}) </span>
            <span class="promotion-header-money bui-num">{{account.advertiser_share_balance}}</span>
            <byted-tag size="sm" type="primary" style="transform: scale(0.83333);">优先消耗</byted-tag>
          </div>
        </div>
      </div>

      <div class="header-right-wrapper ad-d-flex">
        <byted-button type="text"
                      id="keyboard-short-cut"
                      class="header-operation-btn ad-d-flex ad-d-flex-start ad-m-r"
                      @click="$emit('view-shortcut')"
                      >
          <img class="command-svg" :src="CommandSvg" />
          键盘快捷键
        </byted-button>
        <byted-button type="text"
                      class="header-operation-btn ad-d-flex ad-d-flex-start ad-m-r"
                      @click="goToBrandAdvs"
                      v-if="account.is_branding_advertiser">
          <img class="command-svg" :src="SwitchSvg" /> {{ $bp_t('切换至品牌广告', 'bp.promotion_header_change_to_brand')}}
        </byted-button>
      </div>
    </div>

    <!-- 预算和出价 -->
    <budget-bid-modal
    v-model="showBudgetBidModal"
      :budget_bid_data='BudgetBidModalData'
      @cancel="closeBudgetBidModal"
      @submit="onBudgetBidSubmit"
      @delete="onDeleteAdTask"></budget-bid-modal>

    <!-- Modal -->
    <support-shortcut-modal v-model="showModifyBudgetModal"
                 @hidden="onModifyBudgetModalHidden"
                 :title="$bp_t('修改账户预算', 'bp.promotion_header_modify_account_budget')"
                 class="modify-account-budget-modal width480"
                 mask-closable
                 @hide="onClickCancelEditBudget"
                 @ok="onClickConfirmEditBudget"
                 >
      <template slot="body">
        <div class="modify-budget-modal">
          <div class="content-row">
            <div class="label-item">{{ $bp_t('预算方式', 'bp.promotion_header_budget_mode') }}</div>
            <div class="input-item">
              <byted-radio-group v-model="modifiedBudget.budget_mode"
                                 @change="dailyBudgetInputValidator">
                <byted-radio-button :val="noLimitBudgetMode">{{ $bp_t('不限预算', 'bp.promotion_header_unlimited_budget') }}</byted-radio-button>
                <byted-radio-button :val="limitBudgetMode">{{ $bp_t('指定预算', 'common.designated_budget') }}</byted-radio-button>
              </byted-radio-group>
            </div>
          </div>
          <div class="content-row"
               v-show="isLimitModifyingBudgetMode">
            <div class="label-item">{{ $bp_t('账户日预算', 'bp.promotion_header_daily_budget_of_account') }}</div>
            <div class="input-item">
              <byted-input v-model="modifiedBudget.budget"
                           ref="budgetInput"
                           :placeholder="$bp_t('请输入账户日预算', 'bp.promotion_header_enter_daily_budget_account')"
                           :status="modifyBudgetValidMsg ? 'error' : ''"
                           @change="dailyBudgetInputValidator">
              </byted-input>
              <span class="ad-m-l-xs">{{ $bp_t('元', 'common.element') }}</span>
            </div>
          </div>
          <div class="valid-msg"
               v-show="modifyBudgetValidMsg !== ''">{{modifyBudgetValidMsg}}</div>
        </div>
      </template>
      <template slot="footer">
        <byted-button type="default"
                @click="onClickCancelEditBudget">{{ $bp_t('取消', 'common.cancel') }}
        </byted-button><byted-button type="primary"
                @click="onClickConfirmEditBudget">{{ $bp_t('确认', 'common.confirm') }}</byted-button>
      </template>
    </support-shortcut-modal>
  </div>
</template>
<script>
  import Apis from 'Src/const/apis'
  import Tool from 'Src/util/tool.js'
  import Json from 'Src/util/json.js'
  import { budgetAndTimedTask } from 'Src/const/state/statistics-fields-promotion.js'

  import GlobalTips from 'Src/components/global/global-tips.vue'
  import ArrowOut from 'Src/static/images/icon/arrow-out.svg'
  import BudgetBidModal from 'Src/components/promotion/budget-bid-modal.vue'
  import CommandSvg from 'Src/static/images/promotion-command.svg'
  import NewSvg from 'Src/static/images/new.gif'
  import SwitchSvg from 'Src/static/images/icon-switch.svg'
  import { getCurPath } from 'Src/pagelets/promotion/common.js'
  import { PROMOTION_MOUNTED } from 'Src/util/perf-monitor/monitors'
  import { shareStrategyText } from "Src/const/state/share-strategy";

  const TIMED_BUDGET_STATUS = {
    active: 1,
    delete: 2
  }

  export default {
    name: 'promotion-header',
    components: {
      [GlobalTips.name]: GlobalTips,
      [BudgetBidModal.name]: BudgetBidModal,
    },
    data() {
      return {
        noLimitBudgetMode: -1,
        limitBudgetMode: 0,
        account: {
          today_cost: '',
          budget: '',
          balance: '',
          budget_mode: '', // 预算方式(Number)：0 === 指定预算； -1 === 不限预算
          valid_balance: '',
          grant: '',
          cash: '',
          budget_task_info: null,
          is_branding_advertiser: false, // 是否为品牌广告主
          advertiser_wallet_balance: [] // 余额到期情况
        },
        advertiserSharedStrategyText: shareStrategyText,
        showModifyBudgetModal: false,
        modifyBudgetValidMsg: '',
        modifiedBudget: {
          budget: '',
          budget_mode: ''
        },
        ArrowOut: ArrowOut,
        showRechargeBtn: false,
        showBudgetBidModal: false,
        BudgetBidModalData: {
          type: 1,
          value: '0',
          errorMessage: ''
        },
        CommandSvg: CommandSvg,
        NewSvg: NewSvg,
        SwitchSvg: SwitchSvg,
        walletBalanceSoon: false, // 余额到期情况
        balancePopoverHover:false,
      };
    },
    computed: {
      hasAccountData() {
        return (this.account.budget_mode !== '')
      },
      isNoLimitBudgetMode() {
        return (parseInt(this.account.budget_mode) === this.noLimitBudgetMode)
      },
      isLimitModifyingBudgetMode() {
        return (parseInt(this.modifiedBudget.budget_mode) === this.limitBudgetMode)
      },
      costPercentage() {
        let retNum = 0
        if (!this.account.budget_mode) {
          if(this.account.is_branding_advertiser){
            if(!this.account.bid_cost){
              this.account.bid_cost = 0
            }
            retNum = ((this.account.bid_cost / this.account.budget) * 100).toFixed(2)
          }else{
            retNum = ((this.account.today_cost / this.account.budget) * 100).toFixed(2)
          }
        }

        return parseFloat(retNum)
      },
      dateFilter: function () {
        return this.$store.state.dateFilter
      }
    },
    mounted(){
      const onPromotionMountedHandler = e => {
        if (e?.detail?.value === PROMOTION_MOUNTED) {
          this.getAccount()
          this.getShowRechargeData()
          window.removeEventListener('ttistagechange', onPromotionMountedHandler, true)
        }
      }
      window.addEventListener('ttistagechange', onPromotionMountedHandler, true)
    },
    methods: {
      getAccount () {
        BUI.fetch({
          url: Apis.dashboard.account_info,
          success: (resp) => {
            if (resp.code === 0) {
              this.account = resp.data
              // this.account = Object.assign({}, this.account, resp.data)
              if (this.account.budget === '--') {
                this.account.budget = ''
              }
              // 只有钱包里的余额大于0的时候，才会显示，有可能值为0.0，需要过滤处理，也有可能advertiser_wallet_balance字段不返回
              this.account.advertiser_wallet_balance = this.account?.advertiser_wallet_balance?.reduce((total, item) => {
                const data = JSON.parse(item);
                return parseInt(data.grant) > 0 ? total.concat([data]) : total
              }, []) || []
              // 需要分两次计算，第一次过滤数据，避免即将过期的0元影响icon状态
              this.account?.advertiser_wallet_balance?.forEach(item => {
                if (item.is_expire_soon && !this.walletBalanceSoon) {
                  this.walletBalanceSoon = true;
                }
              })

              this.modifiedBudget.budget = resp.data.budget
              this.modifiedBudget.budget_mode = resp.data.budget_mode
            } else {
              this.$message($bp_t('获取账户基本信息失败，内部错误，请刷新重试或联系管理员：', 'bp.promotion_header_account_information_internal') + resp.msg, 'error')
            }
          },
          error: (err) => {
            this.$message($bp_t('获取账户基本信息失败，网络错误，请刷新重试或联系管理员：', 'bp.promotion_header_account_information_network') + err.statusText, 'error')
          }
        })
      },
      // 修改预算
      onClickEditAccountBudget() {
        this.showModifyBudgetModal = true

        if (this.showModifyBudgetModal && this.$refs.budgetInput) {
          setTimeout(() => {
            if (this.$refs.budgetInput && this.$refs.budgetInput.focus) {
              this.$refs.budgetInput.focus()
            }
          }, 350)
        }
      },
      // 修改定时任务
      onClickEditAccountTimeTask() {
        this.BudgetBidModalData.errorMessage = ''
        this.BudgetBidModalData.type = budgetAndTimedTask.timedTask
        this.BudgetBidModalData.value = this.account.budget_task_info ? this.account.budget_task_info.budget : this.account.budget
        this.showBudgetBidModal = true
      },
      resetBudgetModal () {
        this.modifyBudgetValidMsg = ''
        this.showModifyBudgetModal = false

        this.modifiedBudget.budget = Tool.rounding(this.account.budget, 2)
        this.modifiedBudget.budget_mode = this.account.budget_mode
      },
      onClickCancelEditBudget() {
        this.resetBudgetModal()
      },
      saveEditBudget () {
        if (this.modifiedBudget.budget_mode.toString() === this.noLimitBudgetMode.toString()) {
          this.modifiedBudget.budget = ''
        }

        BUI.update({
          contentType: 'application/json',
          url: Apis.promotion.updateBudget,
          data: JSON.stringify(this.modifiedBudget),
          success: (resp) => {
            if (!resp || resp.code) {
              this.$message(resp.msg || $bp_t('修改账户日预算失败，内部错误，请重试或联系管理员', 'bp.promotion_header_failed_modify_account_daily'), 'error')
              return
            }

            this.$message($bp_t('修改账户日预算成功', 'bp.promotion_header_succeeded_modifying_budget'), 'success')
            // this.getAccount() // 该接口的预算更新不及时，不能用
            // （旧版也有这个问题，修改预算为B后，刷新页面，仍是改之前的值A）
            this.account.budget_mode = this.modifiedBudget.budget_mode
            this.account.budget = Tool.rounding(this.modifiedBudget.budget, 2)

            this.showModifyBudgetModal = false
          },
          error: (err) => {
            this.$message('修改账户日预算失败，网络错误，请重试或联系管理员：' + err, 'error')
          }
        });
      },
      onClickConfirmEditBudget() {
        if (this.isLimitModifyingBudgetMode
            && this.modifiedBudget.budget === '') {
          this.modifyBudgetValidMsg = $bp_t('输入不能为空', 'bp.promotion_header_input_cannot_be_empty')
          return
        }

        this.dailyBudgetInputValidator()

        if(this.modifyBudgetValidMsg !== '') {
          return
        }

        // 编辑操作埋点
        window.teaEvent('promotion_edit', {
          referer_path: window.location.pathname + window.location.hash.split('?')[0],
          operation_type: 'accountBudget',
          current_module: 'promotion_list_header',
          budget_mode: this.isLimitModifyingBudgetMode ? 'custom' : 'no_limit',
          budget: this.isLimitModifyingBudgetMode ? Number(this.modifiedBudget.budget) : this.noLimitBudgetMode
        })

        this.saveEditBudget()
      },
      dailyBudgetInputValidator() {
        if (this.modifiedBudget.budget_mode.toString() === this.noLimitBudgetMode.toString()) {
          this.modifyBudgetValidMsg = ''
          return
        }

        let validResult = Tool.validNumberString(this.modifiedBudget.budget)

        if (validResult !== '') {
          this.modifyBudgetValidMsg = validResult
        } else if (parseFloat(this.modifiedBudget.budget) < parseFloat(this.account.today_cost)) {
          this.modifyBudgetValidMsg = $bp_t('修改后的预算不能小于今日消耗', 'bp.promotion_header_revised_budget')
        } else {
          this.modifyBudgetValidMsg = ''
        }
      },
      onModifyBudgetModalHidden() {
        this.resetBudgetModal()
      },
      //检查是否支持推广管理白名单/小流量 不支持则跳转老版页面
      onClickRecharge () {
        window.open(this.globalUpdateQuery(`/cg_trade/finance/wallet?from_app=ad&page=charge`))
      },
      getShowRechargeData() {
        BUI.fetch({
          url: Apis.account.show_recharge,
          success: (resp) => {
            if (resp.code === 0) {
              this.showRechargeBtn = resp.data.show_recharge
            }
          }
        })
      },
      closeBudgetBidModal (val) {
        this.showBudgetBidModal = val
      },
      onBudgetBidSubmit (val) {
        if (val && isNaN(val.value)) {
          this.BudgetBidModalData.errorMessage = $bp_t('请输入正确的数字预算值', 'common.enter_the_correct_value')
          return
        }
        if(this.BudgetBidModalData.type === budgetAndTimedTask.budget) {
          this.saveEditBudget(val)
        }
        if(this.BudgetBidModalData.type === budgetAndTimedTask.timedTask) {
          this.onAccountTimeTaskChange(val, TIMED_BUDGET_STATUS.active)
        }
        // this.BudgetBidModalData.errorMessage = '哈哈哈，你错了!'
        // this.showBudgetBidModal = false
      },
      onAccountTimeTaskChange (val, status) {
        let taskDate = {
          'budget': val ? Number(val.value) : this.account.budget_task_info.budget
        }
        if (this.account.budget_task_info && this.account.budget_task_info.task_id) {
            taskDate = {
              ...taskDate,
              task_id: this.account.budget_task_info.task_id
            }
        }
        if (status === TIMED_BUDGET_STATUS.delete) {
          taskDate.opt_status = 2
        }
        BUI.update({
          contentType: 'application/json',
          url: Apis.promotion.adv_budget_task,
          data: JSON.stringify(taskDate),
          success: (resp) => {
            if (!resp || resp.code) {
              this.$message(resp.msg || $bp_t('修改定时任务失败，内部错误，请重试或联系管理员', 'bp.promotion_header_modify_scheduled_task_inside'), 'error')
              return
            }
            this.showBudgetBidModal = false
            this.$message($bp_t('修改账户定时任务成功', 'bp.promotion_header_succeeded_account_timing_task'), 'success')
            this.getAccount()
          },
          error: (err) => {
            this.$message($bp_t('修改定时任务失败，网络错误，请重试或联系管理员：', 'bp.promotion_header_modify_scheduled_task_network') + err, 'error')
          }
        });
      },
      // 删除定时任务
      onDeleteAccountimeTask () {
        this.BudgetBidModalData.type = budgetAndTimedTask.deleteTask
        this.BudgetBidModalData.errorMessage = ''
        this.showBudgetBidModal = true
      },
      // 确认删除定时任务
      onDeleteAdTask () {
        this.onAccountTimeTaskChange(null, TIMED_BUDGET_STATUS.delete)
      },
      goToBrandAdvs () {
        window.location.href = this.globalUpdateQuery('/overture/data/old_advertiser/campaign/')
      },
      visibleChange (isShow){
        this.balancePopoverHover = isShow
      }
    },
    watch: {
      // 'account.budget': {
      //   deep: true,
      //   handler: function(newV, oldV) {
      //     if (newV) {
      //       this.$set(this.account, 'budget', newV)
      //     }
      //   }
      // },
      // 'account.budget_task_info': {
      //   deep: true,
      //   handler: function(newV, oldV) {
      //     this.$set(this.account, 'budget_task_info', newV)
      //   }
      // }
    }
  };
</script>
<style lang="scss">
.width480{
 div.bui-modal-dialog{
   width:480px;
 }
 .bui-modal-footer{
   padding: 16px 24px 24px;
 }
}
  .promotion-header {
    $basic-height: 16px;
    $number-height: 22px;

    font-size: 14px;
    height: 48px;
    padding: 0 24px;
    background: #fff;
    border-bottom: 1px solid #E4E9ED;

    .balance-popover {
      margin-right: 3px;
      .balance-popover-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        a{
          font-weight: 400;
          font-size: 12px;
          text-decoration: none;
        }
      }
      .bui-icon-question-circle {
        fill: #999;
      }
      .bui-icon-question-circle:hover {
        fill: #666;
      }
      span {
        font-weight: 600;
      }
      .byted-icon {
        vertical-align: middle;
        cursor: pointer;
      }
      .balance-explain {
        margin-top: 8px;
        p {
          font-size: 12px;
          color: #666;
          line-height: 20px;
          margin: 0;
        }
        .balance-explain-mess {
          margin-top: 8px;
        }
      }
    }

    .link-btn {
      display: block;
      height: $number-height;
      line-height: $number-height !important;
    }
    .ad-spliter {
      margin: 0 24px 0 6px;
      background-color: #CFD2D6;
      &-slash {
        margin: 0 16px;
      }
    }
    .bui-icon-company {
      cursor: default;
      width: 16px;
      height: 14px;
    }
    &-advertiser-name {
      font-size:12px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color: #333;
      height: $basic-height;
      //line-height:$basic-height;
      max-width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &-progress {
      cursor: pointer;
      width: 100px;
    }
    &-title {
      font-family:PingFangSC-Medium;
      font-size: 12px;
      font-weight: 500;
      color: #666;
      height: $basic-height;
      //line-height: $basic-height;
      margin-right: 8px;
    }
    &-money {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      line-height: $number-height;
      height: $number-height;
    }
    &-money-edit :hover{
      fill: #2F88FF;
    }
    .byted-icon {
      &.active {
        fill: #2F88FF;
      }
    }

    &-have-bid,&-clock {
      margin-left: 4px;
      margin-right: 16px;
      width: 14px;
      height: 14px;
      display: flex;
      .bui-icon-clock {
        vertical-align: top;
        display: inline-block;
      }
    }
    &-clock:hover {
      .bui-icon-clock {
        display: inline-block;
      }
    }
    .recharge-btn {
      min-width: auto;
      margin-left: 6px;
      font-size: 12px;
      margin-top: 2px;
    }

    .grant-balance{
      .byted-tag-primary:hover{
        background-color: #338aff;
        color: #fff;
        border-color: #338aff;
      }
    }
    .progress-wrapper {
      margin-left: 12px;
      margin-right: 18px;
      .byted-popover-wrapper {
        margin-bottom: -1px;
      }
    }
    .byted-progress {
      height: 4px;
      background-color: #E6EAED;
      &:before {
        display: none;
      }
      .progress-bar-info {
        background-color: #2F88FF;
      }
    }
    .header-operation-btn {
      position: relative;
      line-height: $basic-height;
      font-size: 12px;
      min-width: auto;
      padding: 5px 0;
      .byted-icon {
        $icon-size: 14px;
        width: $icon-size;
        height: $icon-size;
        margin-right: 4px;
      }
      .bui-icon-in {
        margin-right: 4px;
      }
    }
  }
  .modify-budget-modal {
    position: relative;
    .valid-msg {
      display: inline-block;
      position: absolute;
      top: 88px;
      left: 78px;
      font-size: 12px;
    }
  }

  .command-svg {
    margin-left: 4px;
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .new-svg {
    position: absolute;
    right: -20px;
    top: -5px;
    width: 20px;
    height: 12px;
  }
</style>
